/**
 * 面接セッション中はヘッダー・ボトムナビ・フッターを隠し、没入表示にする。
 * Header / BottomNav / AppFooter が共通で参照する（判定ロジックはここ1箇所に集約する）。
 */
export function isInterviewSessionPath(pathname: string | null): boolean {
  return pathname?.startsWith("/interview/session") ?? false;
}

/**
 * 高校生向けの案内ページ配下かどうか（/high-school, /high-school/start 等）。
 *
 * 案内ページはマーケティング共通ヘッダ（TopHeader）を使うため、ページ本体で
 * 対象を絞ってもヘッダの求人リンクが残る。初回訪問時はまだ区分が確定して
 * いないので、区分ではなくパスで判定する必要がある（#1749）。
 */
export function isHighSchoolLandingPath(pathname: string | null): boolean {
  if (!pathname) return false;
  return pathname === "/high-school" || pathname.startsWith("/high-school/");
}
